import {adicRestApi, adicRestApiPangoUrl} from '../index';

export const getPanggoList = async (reqBody = {}) => {
  const url = adicRestApiPangoUrl
    .segment("/video/list")
    .query({size : 141})
    .toString();

  const { data } = await adicRestApi.get(url, reqBody);
  return data;
};
